<template>
  <div id="participation">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          <small>Programme National</small>
          <br>
          Participation
        </h1>
        <hr>
      </div>
    </div>
    <div class="panel panel-info">
      <div class="panel-heading">
        <div class="form-inline">
          <div class="form-group">
            <btn type="primary" @click="importFiles">Importer les données</btn>
          </div>
        </div>
      </div>
    </div>

    <modal v-model="show"
           :header="false"
           :backdrop="false"
           :footer="false">
      <h2>Import des données de participation</h2>
      <div class="row">
        <div class="col-xs-12">
          <p>
            <input ref="fileInput" type="file" single>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
        </div>
      </div>
      <div v-if="completed">
        <btn @click="hide" type="default">Retour</btn>
      </div>
    </modal>

    <div v-if="participation" class="row">
      <div class="col-xs-12">
        <table class="table-responsive table">
          <thead>
            <tr class="info">
              <th>Région</th>
              <th v-for="(c, k) in participation.columns" :key="k">
                {{ c.key }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, k) in participation.rows" :key="`row-${k}`">
              <th>{{ r.label }}</th>
              <td v-for="(v, i) in r.values" :key="`cell-${k}-${i}`">
                {{ v.subscriptions }} / {{ v.entities }} <span v-if="v.percent">({{ v.percent }}%)</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>

import StepIterator from '@/sui/tools/stepiterator'
import steps from '@/sui/components/steps'
import baseSteps from '@/components/sheets/import/impl/steps'
import regions from '@/sui/tools/regions'

// import impl from '@/components/sheets/import/impl/reainfadi'

function getType (t) {
  const types = {
    '101': 'CHRU/CHR',
    '355': 'CH',
    '106': 'HL',
    '114': 'HA',
    '131': 'CLCC',
    '122': 'MCO',
    '128': 'MCO',
    '129': 'MCO',
    '365': 'MCO',
    '109': 'SSR',
    '362': 'SLD',
    '292': 'PSY',
    '127': 'HAD',
    '141': 'DIA',
    '146': 'DIA'
  }

  return types[t]
}

const types = [
  { key: 'CHRU/CHR', prio: true },
  { key: 'HA', prio: true },
  { key: 'CH', prio: true },
  { key: 'MCO', prio: true },
  { key: 'CLCC', prio: true },
  { key: 'DIA', prio: true },
  { key: 'HL', prio: false },
  { key: 'HAD', prio: false },
  { key: 'SSR', prio: false },
  { key: 'PSY', prio: false },
  { key: 'SLD', prio: false }
]

function isPrio (t) {
  const f = types.find((e) => e.key === t)
  if (f != null) {
    return f.prio
  }
  return false
}

function getFiness (f) {
  const result = `${f}`
  if (result.length === 9) {
    return result
  }

  return `0${result}`
}

export default {
  name: 'tools-participation',

  data: function () {
    const steps = [
      baseSteps.load(
        'Base Finess', 'Impossible de charger la base Finess'
      ),
      baseSteps.transform(
        'Ajout des entités juridiques',
        'Impossible de traiter la base Finess',
        (c) => `${c} lignes traitées avec succès.`,
        (vm, data, o, start, end) => {
          if (start === 0) {
            data.entities = {
              unknown: {
                finessJuri: 'unknown',
                types: [],
                subscriptions: []
              }
            }
            data.lookup = {}
          }

          const errors = []
          for (let i = start; i !== end; ++i) {
            const l = o[i]
            if (l.Type == null) {
              errors.push(`Entity ${i}: missing Type`)
              continue
            }

            const type = getType(l.Type)
            if (type == null) {
              continue
            }

            if (l.FinessJuri == null) {
              errors.push(`Entity ${i}: missing FinessJuri`)
              continue
            }

            if (l.FinessGeo == null) {
              errors.push(`Entity ${i}: missing FinessGeo`)
              continue
            }

            const fj = getFiness(l.FinessJuri)
            const fg = getFiness(l.FinessGeo)

            if (type === 'HA' && fj === '750813032') {
              continue
            }

            if (data.entities[fj] == null) {
              data.entities[fj] = {
                finessJuri: fj,
                types: [],
                subscriptions: []
              }
            }
            const entity = data.entities[fj]
            const r = regions.indexOf(fg)

            if (r !== -1 && entity.types.find(e => e.type === type && e.region === r) == null) {
              entity.types.push({ region: r, type: type })
            }
            data.lookup[fg] = fj
          }

          if (errors.length > 0) {
            throw new Error(errors.join('<br />'))
          }
        }
      ),

      baseSteps.load(
        'Inscriptions SPIADI',
        'Impossible de charger la liste des inscriptions'
      ),
      baseSteps.transform(
        'Ajout des inscriptions',
        'Impossible de traiter la liste des inscriptions',
        (c) => `${c} inscriptions traitées avec succès.`,
        (vm, data, o, start, end) => {
          if (start === 0) {
            data.count = []
          }
          const errors = []
          for (let i = start; i !== end; ++i) {
            const l = o[i]

            if (l.Finess == null) {
              errors.push(`Subscription ${i}: missing Finess`)
              continue
            }

            const t = l[`Type d'établissement`]
            if (t == null) {
              errors.push(`Subscription ${i}: missing Type d'établissement`)
              continue
            }

            if (types.find(tt => tt.key === t) == null) {
              continue
            }

            const f = getFiness(l.Finess)
            let entity = data.entities[f]
            if (entity == null) {
              const juri = data.lookup[f]

              if (juri == null || data.entities[juri] == null) {
                entity = data.entities.unknown
              } else {
                entity = data.entities[juri]
              }
            }

            const r = regions.indexOf(f)
            if (r === -1 || r === 17) {
              continue
            }

            if (((r === 0 || r === 9 || r === 16) && t.startsWith('CHR')) ||
                ((r === 9 || r === 16) && t === 'HA') ||
                entity.subscriptions.find(e => e.region === r && e.type === t) == null) {
              entity.subscriptions.push({ region: r, type: t })
            }
          }

          if (errors.length > 0) {
            throw new Error(errors.join('<br />'))
          }
        }
      ),
      {
        title: 'Extraction de la participation',
        index: 0,

        setError: function (e) {
          return `Impossible d'extraire la participation : ${e}.`
        },

        run: function (vm, data, iteration) {
          const entities = {
            France: {
              Prio: 0,
              Total: 0
            }
          }
          const subscriptions = {
            France: {
              Prio: 0,
              Total: 0
            }
          }

          for (let rkey in regions.regions) {
            const n = regions.regions[rkey].name
            entities[n] = {
              Prio: 0,
              Total: 0
            }
            subscriptions[n] = {
              Prio: 0,
              Total: 0
            }
          }

          for (let i = 0; i !== types.length; ++i) {
            const t = types[i].key
            for (let key in entities) {
              entities[key][t] = 0
              subscriptions[key][t] = 0
            }
          }

          for (let key in data.entities) {
            const e = data.entities[key]

            for (let i = 0; i !== e.subscriptions.length; ++i) {
              const s = e.subscriptions[i]
              const r = regions.filters[s.region].name
              const t = s.type

              subscriptions[r][t] += 1
              subscriptions[r].Total += 1
              subscriptions.France[t] += 1
              subscriptions.France.Total += 1
              if (isPrio(t)) {
                subscriptions[r].Prio += 1
                subscriptions.France.Prio += 1
              }
            }

            for (let i = 0; i !== e.types.length; ++i) {
              const t = e.types[i]
              const r = regions.filters[t.region].name
              entities[r][t.type] += 1
              entities[r].Total += 1
              entities.France[t.type] += 1
              entities.France.Total += 1
              if (isPrio(t.type)) {
                entities[r].Prio += 1
                entities.France.Prio += 1
              }
            }
          }

          // Handle HCL
          entities['Auvergne Rhône-Alpes']['CHRU/CHR'] += 13
          entities['Auvergne Rhône-Alpes'].Prio += 13
          entities['Auvergne Rhône-Alpes'].Total += 13

          // Handle APHM
          entities[`Provence-Alpes-Côte-d'Azur`]['CHRU/CHR'] += 5
          entities[`Provence-Alpes-Côte-d'Azur`]['HA'] += 1
          entities[`Provence-Alpes-Côte-d'Azur`].Prio += 6
          entities[`Provence-Alpes-Côte-d'Azur`].Total += 6

          // Handle APHP
          entities[`Île-de-France`]['CHRU/CHR'] += 34
          entities[`Île-de-France`]['HA'] += 1
          entities[`Île-de-France`].Prio += 35
          entities[`Île-de-France`].Total += 35

          entities.France['CHRU/CHR'] += 52
          entities.France['HA'] += 2

          entities.France.Prio += 54
          entities.France.Total += 54

          vm.results = {
            entities,
            subscriptions
          }

          return {
            end: true,
            success: true
          }
        }
      }
    ]

    return {
      show: false,
      iterator: new StepIterator(steps)
    }
  },

  computed: {

    participation: function () {
      if (!this.completed || this.results == null) {
        return null
      }

      const columns = [
        { key: 'CHRU/CHR' },
        { key: 'HA' },
        { key: 'CH' },
        { key: 'MCO' },
        { key: 'CLCC' },
        { key: 'DIA' },
        { key: 'Prio' },
        { key: 'HL' },
        { key: 'HAD' },
        { key: 'SSR' },
        { key: 'PSY' },
        { key: 'SLD' },
        { key: 'Total' }
      ]

      const vmr = this.results
      function buildValue (r, k) {
        const e = vmr.entities[r][k]
        const s = vmr.subscriptions[r][k]

        return {
          entities: e,
          subscriptions: s,
          percent: e > 0 ? (100 * s / e).toFixed(1) : null
        }
      }

      const rows = [{
        label: 'France', values: []
      }]
      for (let k in regions.regions) {
        rows.push(
          { label: regions.regions[k].name, values: [] }
        )
      }
      for (let i = 0; i !== columns.length; ++i) {
        const c = columns[i]

        for (let j = 0; j !== rows.length; ++j) {
          const r = rows[j]
          r.values.push(buildValue(r.label, c.key))
        }
      }
      return {
        columns,
        rows
      }
    },

    completed: function () {
      return this.iterator.completed
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    importFiles: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'steps': steps
  }
}
</script>

<style scoped lang="less">
</style>
